// mark: debug
// const CandidateAQCAUrl = 'https://yunzhao-backend-test.krcedu.com/yunzhao/REST/getCandidateAQCA'
// const StuAQCAUrl = 'https://yunzhao-backend-test.krcedu.com/yunzhao/REST/getStuAQCA'
// const fileUrl = 'https://yunzhao-file-test.krcedu.com/file/'
// mark: release
const CandidateAQCAUrl = 'https://yunzhao-backend.krcedu.com/yunzhao/REST/getCandidateAQCA'
const StuAQCAUrl = 'https://yunzhao-backend.krcedu.com/yunzhao/REST/getStuAQCA'
const fileUrl = 'https://yunzhao-file.krcedu.com/file/'
export const config = {
    CandidateAQCAUrl:CandidateAQCAUrl,
    StuAQCAUrl:StuAQCAUrl,
    fileUrl:fileUrl
}